module.exports = __webpack_public_path__ + "img/MEDIA078.41db0c3e.jpg";